
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class TaxCategoryGrid extends Serenity.EntityGrid<TaxCategoryRow, any> {
        protected getColumnsKey() { return TaxCategoryColumns.columnsKey; }
        protected getDialogType() { return TaxCategoryDialog; }
        protected getIdProperty() { return TaxCategoryRow.idProperty; }
        protected getInsertPermission() { return TaxCategoryRow.insertPermission; }
        protected getLocalTextPrefix() { return TaxCategoryRow.localTextPrefix; }
        protected getService() { return TaxCategoryService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}